import React, { useState, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch } from 'react-instantsearch-dom';

import { orderBy } from 'lodash';
import MenuBar from '../../directory/MenuBar';
import InfiniteHits from './infinite_hits';
import BeatsFilterPanel from './beats_filter_panel';
import ClearRefinementsButton from '../../algolia_search/clear_refinements_button';
import HashtagFilterPanel from './hashtag_filter_panel';
import GenderFilterPanel from './gender_filter_panel';
import CompanyFilterPanel from './company_filter_panel';
import TitleFilterPanel from './title_filter_panel';
import GeoFilterPanel from './geo_filter_panel';
import { DebouncedSearchBox } from '../../debounced_search_box';

function PrUsersSearch({
 view, query, algoliaAppId, algoliaSearchKey, indexName, hideTabs,
}) {
  const [clearGeoSearch, setClearGeoSearch] = useState(false);
  const [clearMenuToggle, setClearMenuToggle] = useState(false);
  const searchBoxRef = useRef(null);

  const searchClient = useMemo(() => algoliasearch(algoliaAppId, algoliaSearchKey), [algoliaAppId, algoliaSearchKey]);

  const handleClearAllSearch = () => {
    setClearGeoSearch(true);
    setClearMenuToggle(true);
    searchBoxRef.current?.clearQuery();
  };

  const handleClearGeoSearch = () => {
    setClearGeoSearch(false);
  };

  const handleClearMenuToggle = () => {
    setClearMenuToggle(false);
  };

  return (
    <div className="ais-InstantSearch">
      <InstantSearch indexName={indexName} searchClient={searchClient}>
        <MenuBar view={view} showNav={!hideTabs}>
          {{
            searchForm: (
              <>
                <DebouncedSearchBox ref={searchBoxRef} autoFocus defaultRefinement={query} className="d-flex me-3" />
                <ClearRefinementsButton
                  buttonText="Clear"
                  clearsQuery={true}
                  onClear={handleClearAllSearch}
                  bootstrapClasses="px-3 btn btn-sm btn-outline-info text-nowrap"
                />
              </>
            ),
          }}
        </MenuBar>

        <div className="row mb-2">
          <div className="col pr-4 text-right">&nbsp;</div>
        </div>

        <div className="row">
          <div className="col-12 col-md-3 pr-0">
            <BeatsFilterPanel
              attribute="_tags"
              transformItems={(items) => orderBy(items, 'label', 'asc')}
              clearMenuToggle={clearMenuToggle}
              onMenuToggleCleared={handleClearMenuToggle}
            />
            <GeoFilterPanel clearGeoSearch={clearGeoSearch} onGeoSearchCleared={handleClearGeoSearch} />
            <CompanyFilterPanel />
            <TitleFilterPanel />
            <HashtagFilterPanel />
            <GenderFilterPanel />
          </div>
          <div className="col">
            <InfiniteHits />
          </div>
        </div>
      </InstantSearch>
    </div>
  );
}

PrUsersSearch.propTypes = {
  view: PropTypes.string,
  query: PropTypes.string,
  algoliaAppId: PropTypes.string.isRequired,
  algoliaSearchKey: PropTypes.string.isRequired,
  indexName: PropTypes.string.isRequired,
  hideTabs: PropTypes.bool,
};

PrUsersSearch.defaultProps = {
  view: 'prs',
  query: '',
  hideTabs: false,
};

export default PrUsersSearch;
